import React, { useState, useEffect } from "react";
import { FaTimesCircle } from "react-icons/fa";
import { Link } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";


const ROWS_PER_PAGE = 10;
const RaiseRejectedVoice = () => {
  const [voices, setVoices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [rejectedCount, setRejectedCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  // Calculate total pages
  const totalPages = Math.ceil(voices.length / ROWS_PER_PAGE);

  // Get current page data
  const paginatedVoices = [...voices].reverse().slice((currentPage - 1) * ROWS_PER_PAGE, currentPage * ROWS_PER_PAGE);

  // Handle page change
  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  useEffect(() => {
    const fetchRejectedVoices = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/get/rejected/ryv/post`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        console.log("Fetched Rejected Voices:", response);
        const rejectedVoices = Array.isArray(response.data.data) ? response.data?.data : [];
        setVoices(rejectedVoices);
        setRejectedCount(rejectedVoices.length);
      } catch (error) {
        console.error("Error fetching rejected voices:", error);
        toast.error("Failed to load rejected voices");
      } finally {
        setLoading(false);
      }
    };
    fetchRejectedVoices();
  }, []);

  return (
    <div className="p-6">
      <ToastContainer position="top-right" autoClose={3000} />
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center mb-6 gap-4">
        <h1 className="text-2xl font-bold text-gray-800">Rejected Raise Voices</h1>
        <div className="flex flex-wrap gap-2">
          <Link to="/raise/runningvoice" className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600">Running Voices</Link>
          <Link to="/raise/approvedvoice" className="px-4 py-2 bg-green-500 text-white rounded-md hover:bg-green-600">Approved Voices</Link>
          <Link to="/raise/underreviewvoice" className="px-4 py-2 bg-yellow-500 text-white rounded-md hover:bg-yellow-600">Under Review Voices</Link>

        </div>
      </div>
      {/* Stats */}
      <div className="mb-8">
        <div className="bg-red-500 p-6 rounded-xl shadow-lg text-white">
          <div className="flex justify-between items-center">
            <div>
              <p className="text-sm font-medium opacity-80">Rejected Voices</p>
              <p className="text-2xl font-bold mt-1">{rejectedCount}</p>
            </div>
            <FaTimesCircle className="w-10 h-10 opacity-80" />
          </div>
        </div>
      </div>
      {/* Content */}
      {loading ? (
        <div className="flex justify-center items-center h-64">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-red-500"></div>
        </div>
      ) : voices.length === 0 ? (
        <div className="bg-white rounded-xl shadow-sm p-8 text-center">
          <FaTimesCircle className="w-16 h-16 mx-auto text-gray-300 mb-4" />
          <h3 className="text-xl font-semibold text-gray-700 mb-2">
            No Rejected Voices
          </h3>
          <p className="text-gray-500">You don't have any rejected voices.</p>
        </div>
      ) : (
        <>
          <div className="overflow-x-auto">
            <table className="min-w-full bg-white rounded-xl shadow-sm border border-gray-100">
              <thead>
                <tr className="bg-red-100 text-red-800">
                  <th className="py-3 px-4 text-left">Media</th>
                  <th className="py-3 px-4 text-left">RYV ID</th>
                  <th className="py-3 px-4 text-left">Description</th>
                  <th className="py-3 px-4 text-left">Rejection Reason</th>
                  <th className="py-3 px-4 text-left">Location</th>
                  <th className="py-3 px-4 text-left">Status</th>
                  <th className="py-3 px-4 text-left">Submitted</th>
                </tr>
              </thead>
              <tbody>
                {paginatedVoices.map((voice) => (
                  <tr key={voice.id} className="border-b hover:bg-red-50">
                    <td className="px-4 py-3 border-b border-gray-100">
                      {voice.image && (
                        <img src={voice.image.startsWith('http') ? voice.image : `${process.env.REACT_APP_API_BASE_URL}/${voice.image.replace(/\\/g, '/')}`} alt="media" className="w-12 h-12 object-cover rounded" />
                      )}
                      {voice.video && (
                        <video src={voice.video.startsWith('http') ? voice.video : `${process.env.REACT_APP_API_BASE_URL}/${voice.video.replace(/\\/g, '/')}`} className="w-12 h-12 object-cover rounded" />
                      )}
                    </td>
                    <td className="py-3 px-4 text-sm text-gray-600">
                      {voice._id}
                    </td>
                    <td className="py-3 px-4 text-sm text-gray-600">
                      {voice.description}
                    </td>
                    <td className="py-3 px-4 text-sm text-gray-600">
                      {voice.rejectionNote}
                    </td>
                    <td className="py-3 px-4">
                      {voice.city} ({voice.state})
                    </td>
                    <td className="py-3 px-4">{voice.status}</td>
                    <td className="py-3 px-4">{voice.createdAt ? new Date(voice.createdAt).toLocaleString() : "N/A"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {/* Pagination Controls */}
          {totalPages > 1 && (
            <div className="flex justify-center mt-6">
              <nav className="inline-flex flex-wrap items-center gap-1 sm:gap-2">
                <button
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                  className={`px-3 py-1 rounded-l border border-yellow-400 text-yellow-800 bg-white hover:bg-yellow-100 transition-colors ${currentPage === 1 ? 'opacity-50 cursor-not-allowed' : ''}`}
                  aria-label="Previous Page"
                >
                  Previous
                </button>
                {Array.from({ length: totalPages }, (_, idx) => idx + 1).map((pageNum) => (
                  <button
                    key={pageNum}
                    onClick={() => handlePageChange(pageNum)}
                    className={`px-3 py-1 border border-yellow-400 text-yellow-800 bg-white hover:bg-yellow-100 transition-colors ${currentPage === pageNum ? 'bg-yellow-300 text-yellow-900 font-bold' : ''}`}
                    aria-current={currentPage === pageNum ? 'page' : undefined}
                  >
                    {pageNum}
                  </button>
                ))}
                <button
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                  className={`px-3 py-1 rounded-r border border-yellow-400 text-yellow-800 bg-white hover:bg-yellow-100 transition-colors ${currentPage === totalPages ? 'opacity-50 cursor-not-allowed' : ''}`}
                  aria-label="Next Page"
                >
                  Next
                </button>
              </nav>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default RaiseRejectedVoice;
